import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { RoutesPaths, statusOptions, customStyles } from "../Router/constant";
import { getPartners, deletePartnerById } from "../Services/partnerService";
import ConfirmationModal from "../Components/ConfirmationModal";
import { toast } from "react-toastify";
import Select from "react-select";
import Skeleton from "../Components/SkeletonLoader";

export default function Partners() {
    const [loading, setLoading] = useState(true);
    const [partnerData, setPartnerData] = useState([]);
    const [offset, setOffset] = useState(1);
    const [limit] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [status, setStatus] = useState("");
    const [confirmation, setConfirmation] = useState({ show: false, userId: null });
    const [deleteReason, setDeleteReason] = useState("");
    const [allData, setAllData] = useState({});
    const [search, setSearch] = useState("");

    useEffect(() => {
        fetchAllData();
    }, [offset, status, search]);

    const fetchAllData = async () => {
        setLoading(true);
        try {
            const response = await getPartners({ offset, limit, status, search });
            const partners = response?.data?.data || [];
            const allData = response?.data || {};
            setPartnerData(partners);
            setAllData(allData?.statusCounts);
            setTotalCount(allData?.count || 0);
        } catch (error) {
            console.error("Error fetching partners:", error);
            setPartnerData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteClick = (userId) => {
        setConfirmation({ show: true, userId });
        setDeleteReason("");
    };

    const handleConfirmDelete = async () => {
        try {
            if (!deleteReason.trim()) {
                toast.error("Please provide a reason for deletion.");
                return;
            }

            if (confirmation.userId) {
                const response = await deletePartnerById(confirmation.userId, { message: deleteReason });

                if (response.data?.status === true || response.data?.status === 1) {
                    toast.success("Vendor deleted successfully.");
                    fetchAllData();
                    setConfirmation({ show: false, userId: null });
                    setDeleteReason("");
                } else {
                    toast.error(response.data?.message || "Failed to delete vendor.");
                }
            }
        } catch (error) {
            console.error("Error deleting partner:", error);
            toast.error("Something went wrong while deleting vendor.");
        }
    };

    const handleCancelDelete = () => {
        setConfirmation({ show: false, userId: null });
        setDeleteReason("");
    };
    const generatePagination = (currentPage, totalPages) => {
        const pages = [];

        if (totalPages <= 4) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 2) {
                pages.push(1, 2, '...', totalPages - 1, totalPages);
            } else if (currentPage <= 4) {
                pages.push(3, 4, '...', totalPages - 1, totalPages);
            } else if (currentPage >= totalPages - 2) {
                for (let i = totalPages - 2; i <= totalPages; i++) pages.push(i);
            } else {
                pages.push(currentPage, currentPage + 1, '...', totalPages - 1, totalPages);
            }
        }

        return pages;
    };

    return (
        <div className="container-fluid">
            <div className="row dashboardSection">
                <div className="logisticsMenu">
                    <p>
                        <NavLink to={RoutesPaths.DASHBOARD}>
                            <img src="/assets/img/homeIcon.svg" alt="" />
                        </NavLink>
                    </p>
                        <img src="/assets/img/chevron-right.svg" alt="" />
                    <p>
                        Vendors
                    </p>
                </div>
                {/* Summary cards */}
                {[
                    { label: "Total vendors", key: "total", img: "/assets/img/totalBooking.png" },
                    { label: "Pending vendors", key: "pending", img: "/assets/img/unpaid.jpg" },
                    { label: "Rejected vendors", key: "rejected", img: "/assets/img/checkin.png" },
                    { label: "Accepted vendors", key: "accepted", img: "/assets/img/checkout.png" },
                ].map(({ label, key, img }) => {
                    const count =
                        key === "total"
                            ? (allData?.pending || 0) + (allData?.rejected || 0) + (allData?.accepted || 0)
                            : allData?.[key] || 0;

                    return (
                        <div className="col-md-3" key={label}>
                            <div className="bookingManagement">
                                <div>
                                    {loading ? (
                                        <Skeleton width={60} />
                                    ) : (
                                        <h6 className="m-0">{count}</h6>
                                    )}
                                    {loading ? (
                                        <Skeleton width={100} />
                                    ) : (
                                        <p className="m-0">{label}</p>
                                    )}
                                </div>
                                <img src={img} alt={label} className="img-fluid" />
                            </div>
                        </div>
                    );
                })}

                {/* Vendor Table Section */}
                <div className="col-md-12 bookingDetailsMain">
                    <div className="bookingDetailsOuter">
                        <div className="bookingDetailsAlign">
                            <h6 className="bookingDetailsTitle p-0">Vendors</h6>
                            <div className="bookingDetailsOuterRight">
                                <div className="customSelectWrapper">
                                    <Select
                                        className="searchInputSelect"
                                        options={statusOptions}
                                        value={statusOptions.find((opt) => opt.value === status)}
                                        onChange={(selected) => setStatus(selected.value)}
                                        styles={customStyles}
                                    />
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="searchInput"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="TableOverFlow">
                            <div className="bookingContent bookingDetailsHeader">
                                <div className="m-0 companyNameWidth">Company name</div>
                                <div className="m-0 companyEmailWidth">Registration / Tax id</div>
                                <div className="m-0 userPhoneWidth">Phone number</div>
                                <div className="m-0 yourEstablished">Year of experience</div>
                                <div className="m-0 partneruserStatus">Status</div>
                                <div className="m-0 statusWidth">Date</div>
                                <div className="m-0 bookingActionwidth">Action</div>
                            </div>

                            <div>
                                {loading ? (
                                    [...Array(5)].map((_, i) => (
                                        <div key={i} className="bookingContent bookingContentData">
                                            <div className="m-0 companyNameWidth"><Skeleton width={100} /></div>
                                            <div className="m-0 companyEmailWidth"><Skeleton width={140} /></div>
                                            <div className="m-0 userPhoneWidth"><Skeleton width={80} /></div>
                                            <div className="m-0 yourEstablished"><Skeleton width={80} /></div>
                                            <div className="m-0 partneruserStatus"><Skeleton width={80} /></div>
                                            <div className="m-0 statusWidth"><Skeleton width={80} /></div>
                                            <div className="m-0 bookingActionButtons bookingActionwidth">
                                                <Skeleton width={80} height={20} />
                                            </div>
                                        </div>
                                    ))
                                ) : partnerData.length > 0 ? (
                                    partnerData.map((user) => (
                                        <div className="bookingContent bookingContentData" key={user._id}>
                                            <div className="m-0 companyNameWidth">{user.companyName}</div>
                                            <div className="m-0 companyEmailWidth">{user.businessRegistrationNumber || "N/A"}</div>
                                            <div className="m-0 userPhoneWidth">{user.phone}</div>
                                            <div className="m-0 yourEstablished">{user.yearOfExperience || 0}</div>
                                            <div className="partneruserStatus">
                                                <span
                                                    className={`badgeBooking ${user.status?.toLowerCase() || ""}Badge widthFitContent`}
                                                >
                                                    <span>{user.status || "N/A"}</span>
                                                </span>
                                            </div>
                                            <div className="m-0 statusWidth">
                                                {new Date(user.createdAt).toLocaleDateString("en-GB")}
                                            </div>
                                            <div className="m-0 bookingActionButtons bookingActionwidth">
                                                <NavLink
                                                    to={`${RoutesPaths.PARTNERSDETAIL}/${user._id}`}
                                                    style={{ textDecoration: "none" }}
                                                >
                                                    <p className="m-0">
                                                        <img src="/assets/img/view-filled.svg" alt=" " /> View
                                                    </p>
                                                </NavLink>
                                                <p className="m-0 deleteIcon" onClick={() => handleDeleteClick(user._id)}>
                                                    <img src="/assets/img/delete-primary.svg" alt=" " /> Delete
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="noOrders">No vendors found</p>
                                )}
                            </div>
                        </div>
                        {totalCount > 0 && Math.ceil(totalCount / limit) > 1 && (
                            <div className="paginationSection">
                                <p
                                    onClick={() => offset > 1 && setOffset(offset - 1)}
                                    style={{
                                        opacity: offset > 1 ? 1 : 0.5,
                                        pointerEvents: offset > 1 ? 'auto' : 'none',
                                        cursor: offset > 1 ? 'pointer' : 'default'
                                    }}
                                >
                                    <img src="/assets/img/arrow-left.svg" alt="Previous" />
                                </p>

                                {generatePagination(offset, Math.ceil(totalCount / limit)).map((page, idx) =>
                                    page === '...' ? (
                                        <p key={idx} className="ellipsis">...</p>
                                    ) : (
                                        <p
                                            key={idx}
                                            onClick={() => setOffset(page)}
                                            style={{
                                                fontWeight: offset === page ? 'bold' : 'normal',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {page}
                                        </p>
                                    )
                                )}

                                <p
                                    onClick={() => offset < Math.ceil(totalCount / limit) && setOffset(offset + 1)}
                                    style={{
                                        opacity: offset < Math.ceil(totalCount / limit) ? 1 : 0.5,
                                        pointerEvents: offset < Math.ceil(totalCount / limit) ? 'auto' : 'none',
                                        cursor: offset < Math.ceil(totalCount / limit) ? 'pointer' : 'default'
                                    }}
                                >
                                    <img src="/assets/img/arrow-right.svg" alt="Next" />
                                </p>
                            </div>
                        )}

                        {/* Delete Confirmation Modal */}
                        <ConfirmationModal
                            show={confirmation.show}
                            title="Confirm delete"
                            onConfirm={handleConfirmDelete}
                            onCancel={handleCancelDelete}
                            confirmText="Yes, delete"
                            cancelText="Cancel"
                        >
                            <p>Do you really want to delete this vendor?</p>
                            <textarea
                                value={deleteReason}
                                onChange={(e) => setDeleteReason(e.target.value)}
                                placeholder="Enter reason for deletion..."
                                rows="4"
                                style={{
                                    width: "100%",
                                    marginTop: "10px",
                                    padding: "8px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                        </ConfirmationModal>
                    </div>
                </div>
            </div>
        </div>
    );
}
